import Backbone from 'backbone';

export class RemainingLimitsModel extends Backbone.Model {
    defaults() {
        return {
            authorizationType: '',
            channelId: '',
        };
    }
}
